import { render, staticRenderFns } from "./UserEducationUpdateModal.vue?vue&type=template&id=5d6af1fd&scoped=true&"
import script from "./UserEducationUpdateModal.vue?vue&type=script&lang=js&"
export * from "./UserEducationUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./UserEducationUpdateModal.vue?vue&type=style&index=0&id=5d6af1fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6af1fd",
  null
  
)

export default component.exports